import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getAllAssignedQueries = (queryCategory, epoch, pageSize) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.MY_QUERIES.GET_ALL_ASSIGNED_QUERIES(
      queryCategory,
      epoch,
      pageSize
    ),
    "",
  );
};

export default getAllAssignedQueries;
